import React from 'react';
import { DocumentPreview } from 'components/media/DocumentPreview';

export const PDFPreview = ({ url, name, intl, downloadName }) => (
  <DocumentPreview
    url={url}
    name={name}
    intl={intl}
    downloadName={downloadName}
  >
    <DocumentPreview.DocumentTitle type="pdf" />
    <DocumentPreview.Preview />

    <DocumentPreview.Actions
      download
      view
    />
  </DocumentPreview>
);
